export const supabaseClientOptions = Object.freeze({
  auth: Object.freeze({
    // Use an authorization code with PKCE instead of returning session tokens
    // in the OAuth callback URL fragment.
    flowType: 'pkce',
    detectSessionInUrl: true,
  }),
});
